import { useTRPC } from "@nwga/features/client";
import { JobManageList } from "@nwga/features/jobs/ui";
import { Button } from "@nwga/ui/components/button";
import { Skeleton } from "@nwga/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { PageHeader } from "../../../../components/page-header.tsx";

export const Route = createFileRoute("/dashboard/$businessSlug/jobs/")({
	component: ManageListingsPage,
	loader: async ({ context, params }) => {
		const business = await context.queryClient.ensureQueryData(
			context.trpc.businesses.bySlug.queryOptions({
				slug: params.businessSlug,
			}),
		);

		return context.queryClient.ensureQueryData(
			context.trpc.jobs.forBusiness.queryOptions({
				businessId: business.id,
				limit: 100,
			}),
		);
	},
});

function ManageListingsPage() {
	const { businessSlug } = Route.useParams();
	const trpc = useTRPC();
	const business = useQuery(
		trpc.businesses.bySlug.queryOptions({ slug: businessSlug }),
	);

	if (!business.isSuccess) return <Skeleton className="h-72 w-full" />;

	return (
		<div className="space-y-6">
			<PageHeader
				title="Job listings"
				description="Everything you have written, live or not."
				actions={
					<Button asChild>
						<Link
							to="/dashboard/$businessSlug/jobs/new"
							params={{ businessSlug }}
						>
							<PlusIcon className="size-4" aria-hidden="true" />
							New listing
						</Link>
					</Button>
				}
			/>

			<JobManageList
				businessId={business.data.id}
				businessSlug={businessSlug}
				canPublish={business.data.status === "active"}
			/>
		</div>
	);
}
